import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchData, {
  CreateEntry,
  GetList,
  UpdateEntry,
} from "../../providers/dataProvider";
import { CheckNull } from "../../utils/Validate";
import urls from "../../constants";

const useForm = (params) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [values, setValues] = useState({
    roleName: "",
    createdBy: localStorage.getItem("authidentity"),
    rolePermissions: [],
    isActive: true,
    onlyForDistributor: false,
    canViewCosting: false,
  });

  const [editRole, setEditRole] = useState({
    row: null,
    id: null,
  });
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [show, setShow] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [parentMenuList, setParentMenuList] = useState([]);
  const [subMenuList, setSubMenuList] = useState([]);

  const navigate = useNavigate();
  const [listData, setListData] = useState({});

  const { data: menuList } = FetchData("menu", { applicationCode: urls.APPLICATION_CODE });

  useEffect(() => {
    const parentMenu = menuList
      ?.filter((obj) => obj?.isParent && obj?.menuName != "Dashboard")
      ?.sort((a, b) => (a?.menuSequence || 0) - (b?.menuSequence || 0));
    const subMenu = menuList?.filter((obj) => !obj?.isParent);
    setSubMenuList(subMenu);
    setParentMenuList(parentMenu);

    if (parentMenu?.length && selectedParent === null) {
      setSelectedParent(parentMenu[0]?.id);
    }
  }, [menuList]);


  useEffect(() => {
    if (location?.state && location?.state?.roleView == "view") {
      setEditRole({
        id: location?.state?.item?.id,
        row: location?.state?.item,
      });
    }
    else if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard");
        setEditRole({
          id: item?.id,
          row: item?.row,
        });
      } else {
        if (item?.canAdd !== true) navigate("/dashboard");
      }
    } else if (params == undefined) {
      navigate("/dashboard");
    }
  }, []);


  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    setErrors((prev) => {
      if (!prev?.[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const handleStatusChange = (e, params) => {
    if (params == "applicable") {
      setValues({
        ...values,
        onlyForDistributor: e.target.checked,
      });
    }
    if (params == "isActive") {
      setValues({
        ...values,
        isActive: e.target.checked,
      });
    }
    if (params == "costing") {
      setValues({
        ...values,
        canViewCosting: e.target.checked,
      });
    }
  };
  const handleSubmit = (list) => {
    if (!values?.id) {
      const finalValues = {
        roleName: values?.roleName,
        createdBy: values?.createdBy,
        rolePermissions: list,
        onlyForDistributor: values?.onlyForDistributor,
        canViewCosting: values?.canViewCosting,
        applicationCodes: [urls.APPLICATION_CODE]
      };
      CreateEntry(
        "userrole",
        finalValues,
        setCreateMsg,
        "User role created successfully",
        "Failed to create user role"
      );
    } else {
      const finalValues = {
        roleName: values?.roleName,
        modifiedBy: values?.modifiedBy,
        rolePermissions: list,
        isActive: values?.isActive,
        id: values?.id,
        onlyForDistributor: values?.onlyForDistributor,
        canViewCosting: values?.canViewCosting,
        applicationCodes: [urls.APPLICATION_CODE]
      };
      UpdateEntry(
        "userrole",
        finalValues,
        setCreateMsg,
        "User role updated successfully",
        "Failed to update user role"
      );
    }
  };
  useEffect(() => {
    if (!editRole?.id && !menuList?.length) return;
    if (editRole?.id) {
      setValues({
        roleName: editRole?.row?.roleName,
        modifiedBy: editRole?.row?.modifiedBy,
        role: editRole?.row?.rolePermissions,
        roleId: editRole?.id,
        id: editRole?.id,
        isActive: editRole?.row?.isActive,
        onlyForDistributor: editRole?.row?.onlyForDistributor,
        canViewCosting: editRole?.row?.canViewCosting
      });
    }
  }, [editRole, menuList]);

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes('Failed')) {
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setLoading(false);
    } else if (
      createMsg?.message == "User role created successfully" ||
      createMsg?.message == "User role updated successfully"
    ) {
      setShow(true);
      setValues({});
    }
  }, [createMsg]);

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  const SuccessDoneClick = () => {
    setShow(false);
    setLoading(false);
    if (createMsg?.message == "Role deleted successfully")
      GetList("userrole", "", setListData);
    else navigate("/role-management");
  };

  return {
    parentMenuList,
    handleSubmit,
    values,
    setValues,
    subMenuList,
    setSubMenuList,
    menuList,
    handleFormChange,
    errors,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    selectedParent,
    setSelectedParent,
    handleStatusChange,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    listData,
    setListData,
    loading,
    setLoading,
    setErrors
  };
};

export default useForm;